export default () => ({
  errorTrue: false,
  mobileMenuOn: false
})



// WEBPACK FOOTER //
// ./src/app/profile-public/professional/resources/data.js